// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-assets_dashboard_js-rewritten-packages_ember-svg-jar_3886aa02_node_modules_ember-svg--cc97d3","rewritten-packages_ember-svg-jar_3886aa02_node_modules_ember-svg-jar_inlined_sync_recursive_--eae0d3"], () => (__webpack_require__("./assets/dashboard.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
